import { SET_CACHE, SET_FRAME, RESET } from "./SliderAction";

/**
 *
 * @param {*} state
 * @param {*} action
 * Reducer for plugin loader visibility
 *
 */
const DashboardSliderReducer = (
  state = {
    cache: null,
    frame: null
  },
  action
) => {
  switch (action.type) {
    case SET_CACHE:
      return {
        ...state,
        cache: action.payload,
      };
    case SET_FRAME:
      return {
        ...state,
        frame: action.payload,
      };
    case RESET:
      return {
        cache: null,
        frame: null
      }
    default:
      return state;
  };
};

export default DashboardSliderReducer;